import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated, hasValidSession } from '../../utils/auth';
import { useIdleLogout } from '../../hooks/useIdleLogout';

const PrivateRoute: React.FC = () => {
  // Mitigates finding #6 (token in localStorage, XSS-readable) by bounding
  // how long an idle authenticated session - and therefore a stolen token -
  // stays valid. See hooks/useIdleLogout.ts for the full reasoning.
  useIdleLogout();

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (!hasValidSession()) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
